import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlackHole: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBlackHole"><Path fillRule="evenodd" clipRule="evenodd" d="M5.56359 18.9874L2.5 21.6425V12C2.5 6.75334 6.75329 2.50004 12 2.50004C14.3898 2.50004 16.5744 3.38326 18.2435 4.83971L21.5 2.32031V12C21.5 17.2467 17.2467 21.5 12 21.5C9.51689 21.5 7.25553 20.5466 5.56359 18.9874ZM12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlackHole;
